import React from "react";

const LauncherIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28">
    <g data-name="Group 4658">
      <g data-name="Group 4657">
        <circle cx="14" cy="14" r="14" data-name="Ellipse 3" fill="#eee" />
      </g>
      <path
        d="M20.955 8.221L18.54 19.608c-.182.8-.657 1-1.332.625l-3.679-2.711-1.775 1.707a.925.925 0 01-.739.361l.264-3.747 6.818-6.161c.3-.265-.064-.411-.46-.147l-8.43 5.308-3.629-1.136c-.789-.246-.8-.789.165-1.168l14.194-5.468c.657-.247 1.232.146 1.018 1.15z"
        data-name="Path 524"
      />
    </g>
  </svg>
);

export default LauncherIcon;
